module.exports = __webpack_public_path__ + "img/lg_ring_r_s_1_null@2x.0d031897.png";